import React from 'react'

const ProductDescription = ({ description }) => {
  return (
    <div className="cover-deskripsi">
      <h2>Deskripsi</h2>
      <p className="text">{description}</p>
    </div>
  )
}

export default ProductDescription
